import { render, staticRenderFns } from "./AreasOfConcernIntroSection.vue?vue&type=template&id=f0c82d18&"
import script from "./AreasOfConcernIntroSection.vue?vue&type=script&lang=js&"
export * from "./AreasOfConcernIntroSection.vue?vue&type=script&lang=js&"
import style0 from "./AreasOfConcernIntroSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports